export default __webpack_public_path__ + "static/2-d933d80f679d4db58afca066761a5363.png";